import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { auth } from "./auth"

export default function ProtectedRoute({ children }) {
  const location = useLocation()

  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return children
}
